import React, { Component } from 'react';
import { bool, func, string } from 'prop-types';
import Select from 'ps-components/ReactSelect/ReactSelect';
import classNames from 'classnames';
import ActionableHeaderCard from 'ps-components/Card/ActionableHeaderCard';

const options = [
  {
    value: 'zero',
    label: 'Zero Weight'
  },
  { value: 'current', label: 'Current Weight' }
];
class MatchExceptions extends Component {
  static propTypes = {
    typeOfReview: string,
    autoReviewOption: string,
    isPriorityMatch: bool,
    setTypeOfReview: func,
    setAutoReviewOption: func,
    dataCutOptionsSaved: bool,
    noExceptions: bool
  };

  constructor(props) {
    super(props);
    this.onRadioChange = this.onRadioChange.bind(this);
    this.onSelectChange = this.onSelectChange.bind(this);
    this.onRadioChangeAuto = this.onRadioChangeAuto.bind(this);
    this.onRadioChangeManual = this.onRadioChangeManual.bind(this);
    this.onRadioChangeSkip = this.onRadioChangeSkip.bind(this);
  }

  onRadioChange(type) {
    const { setTypeOfReview } = this.props;
    setTypeOfReview(type);
  }

  onRadioChangeAuto() {
    this.onRadioChange('auto');
  }

  onRadioChangeManual() {
    this.onRadioChange('manual');
  }

  onRadioChangeSkip() {
    this.onRadioChange('skip');
  }

  onSelectChange(select) {
    const { setAutoReviewOption } = this.props;
    setAutoReviewOption(select ? select.value : 'current');
  }

  render() {
    const { typeOfReview, autoReviewOption, isPriorityMatch, noExceptions, dataCutOptionsSaved } = this.props;
    const selectedOption = autoReviewOption ? options.find(({ value }) => value === autoReviewOption) : options[0];
    let matchText = !noExceptions
      ? 'Some selected surveys don’t have data cut change set-up'
      : 'Decisions for Data Cut Exceptions';
    if (isPriorityMatch) matchText += ' by Data Cut Priority';
    return (
      <ActionableHeaderCard
        cardTitleClassName={classNames({
          'color-red': !noExceptions,
          'survey-migration-settings__heading': noExceptions
        })}
        className="survey-migration-settings__panel"
        cardTitle={matchText}
      >
        {!noExceptions && (
          <label className="pxl-option pxl-option--radio pxl-option--primary match-selection__option option-skip">
            <input
              id="Skip"
              type="checkbox"
              value="skip"
              checked={typeOfReview === 'skip'}
              className="pxl-option__input"
              onClick={this.onRadioChangeSkip}
            />
            <div
              className={classNames('pxl-option__text pxl-text-small match-selection__text', {
                selected: typeOfReview === 'skip'
              })}
            >
              Skip Migrating these surveys
            </div>
          </label>
        )}
        <div className="preserve-match-group match-selection__option">
          <label className="pxl-option pxl-option--radio pxl-option--primary option-auto">
            <input
              id="Preserve"
              type="checkbox"
              value="auto"
              checked={typeOfReview === 'auto'}
              className="pxl-option__input"
              onClick={this.onRadioChangeAuto}
            />
            <div
              className={classNames('pxl-option__text pxl-text-small match-selection__text text-preserve', {
                selected: typeOfReview === 'auto'
              })}
            >
              Preserve These Matches With{' '}
            </div>
          </label>
          <Select
            className="preserve-select pxl-text-small"
            name="form-field-name"
            clearable={false}
            value={selectedOption}
            options={options}
            onChange={this.onSelectChange}
          />
        </div>
        <label className="pxl-option pxl-option--radio pxl-option--primary match-selection__option option-manual">
          <input
            id="Review"
            type="checkbox"
            value="manual"
            checked={typeOfReview === 'manual'}
            className="pxl-option__input"
            onClick={this.onRadioChangeManual}
          />
          <div
            className={classNames('pxl-option__text pxl-text-small match-selection__text', {
              selected: typeOfReview === 'manual'
            })}
          >
            I Want to Review These Matches
            <p className="match-selection-manual__subtext">you can preserve or update data cuts for them later</p>
          </div>
        </label>
      </ActionableHeaderCard>
    );
  }
}

export default MatchExceptions;
